import { API, authClient } from "..";

// Get all answers, optionally filtered by game
export const getAnswers = (gameId) => {
	const params = gameId ? { game: gameId } : {};
	return authClient().get(`${API}/answer`, { params });
};

// Get the specified answer
export const getAnswerById = (id) => {
	return authClient().get(`${API}/answer/${id}`);
};
// Get the specified answer by quiz (optional: filter by game)
export const getAnswerByQuiz = (quizId, params = {}) => {
	return authClient().get(`${API}/answer/quiz/${quizId}`, { params });
};

// Get scenario answers (optional filter by game - only answers from groups of that game)
export const getAnswersByScenario = (id, gameId) => {
	return authClient().get(`${API}/answer/scenario/${id}`, gameId ? { params: { game: gameId } } : {});
};
